import React, { useEffect, useState } from "react";

export const PATIENT_PREFIX = "patient:";
export const PROVIDER_PREFIX = "provider:";

type RescheduleReasonProps = {
  value: string;
  patientReplacement?: string;
  providerReplacement?: string;
} & React.HTMLAttributes<HTMLSpanElement>;

function RescheduleReason({
  value,
  patientReplacement = PATIENT_PREFIX,
  providerReplacement = PROVIDER_PREFIX,
  title = "",
  ...rest
}: RescheduleReasonProps) {
  const [displayValue, setDisplayValue] = useState<string>("");

  useEffect(() => {
    let originalValue = value;
    if (originalValue.indexOf(PATIENT_PREFIX) !== -1) {
      originalValue = originalValue.replace(
        PATIENT_PREFIX,
        `<span class="text-orange-400 capitalize cursor-default" title="This reason was provided by patient">${patientReplacement}</span>`
      );
    }
    if (originalValue.indexOf(PROVIDER_PREFIX) !== -1) {
      originalValue = originalValue.replace(
        PROVIDER_PREFIX,
        `<span class="text-green-400 capitalize cursor-default" title="This reason was provided by provider">${providerReplacement}</span>`
      );
    }
    setDisplayValue(originalValue);
  }, [value, patientReplacement, providerReplacement]);

  return (
    <span
      className="hover:text-emphasis cursor-default"
      dangerouslySetInnerHTML={{ __html: displayValue }}
      title={title?.replace(PATIENT_PREFIX, "").replace(PROVIDER_PREFIX, "")}
      {...rest}
    />
  );
}

export default RescheduleReason;
